import { brand, footer, contact } from "../content/site";

export default function Footer() {
  const go = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-navy text-cream">
      <div className="container-edge py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="inline-flex items-center rounded-sm bg-cream px-4 py-3">
              <img src={brand.logo} alt="Laundry Ventures logo" className="h-9 w-auto object-contain" />
            </div>
            <a
              href="https://laundryloungemeridian.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-lounge-link"
              className="mt-6 block max-w-xs font-serif text-2xl italic leading-snug text-cream/90 transition-colors hover:text-brass"
            >
              {brand.concept} Meridian
            </a>
            <p className="mt-4 max-w-xs font-sans text-sm font-light leading-relaxed text-cream/50">
              A modern, attended, hospitality-driven laundry experience by {brand.parent}.
            </p>
          </div>

          {/* Link columns */}
          {footer.columns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="font-sans text-[10px] uppercase tracking-overline text-brass">{col.title}</p>
              <ul className="mt-6 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      onClick={(e) => go(e, l.href)}
                      className="font-sans text-sm text-cream/60 transition-colors hover:text-cream"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact + social */}
          <div className="lg:col-span-3">
            <p className="font-sans text-[10px] uppercase tracking-overline text-brass">Contact</p>
            <a
              href={`mailto:${contact.email}`}
              data-testid="footer-email-link"
              className="mt-6 block font-sans text-sm text-cream/60 transition-colors hover:text-cream break-all"
            >
              {contact.email}
            </a>
            <div className="mt-6 flex gap-5">
              {footer.social.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="link-underline font-sans text-xs uppercase tracking-widest text-cream/60 hover:text-cream"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-cream/12 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-sans text-xs text-cream/40">{footer.copyright}</p>
          <div className="flex gap-6">
            {footer.legal.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="font-sans text-xs text-cream/40 transition-colors hover:text-cream/80"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
